import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("aip_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// On 401 (e.g., session revoked after a password change), clear state and
// bounce to /login — but skip if we're already on the login flow, and skip
// for the /auth/me probe so AuthProvider can handle a clean unauthenticated state.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    const url = err?.config?.url || "";
    if (status === 401 && !url.includes("/auth/")) {
      try {
        localStorage.removeItem("aip_token");
        localStorage.removeItem("aip_admin_token");
        localStorage.removeItem("aip_impersonating");
        if (!/\/(login|register|interview\/)/.test(window.location.pathname)) {
          window.location.href = "/login";
        }
      } catch {
        /* ignore */
      }
    }
    return Promise.reject(err);
  }
);

export default api;
